// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1SD_0","itemTitle":"ClientEmergencyInfo_itemTitle__2CWrt","itemText":"ClientEmergencyInfo_itemText__2chyq"};